import { useState } from 'react';
import { buildScoreChallengeUrl, buildTableShareUrl, shareUrl, type ShareResult } from './share';
import styles from './ShareActions.module.css';

interface ShareActionsProps {
  tableId: string;
  tableName: string;
  score?: number;
  challenger?: string | null;
  compact?: boolean;
}

function feedback(result: ShareResult, kind: 'table' | 'challenge'): string {
  if (result === 'shared') return kind === 'challenge' ? 'Challenge shared.' : 'Table shared.';
  if (result === 'copied') return kind === 'challenge' ? 'Challenge link copied.' : 'Table link copied.';
  if (result === 'unavailable') return 'Sharing is unavailable in this browser.';
  return '';
}

export default function ShareActions({
  tableId,
  tableName,
  score,
  challenger,
  compact = false,
}: ShareActionsProps) {
  const [status, setStatus] = useState('');
  const hasScore = typeof score === 'number' && Number.isFinite(score);

  const shareTable = async () => {
    const result = await shareUrl({
      title: `${tableName} · Balls of Pin`,
      text: `Play ${tableName} on Balls of Pin.`,
      url: buildTableShareUrl(tableId),
    });
    setStatus(feedback(result, 'table'));
  };

  const shareChallenge = async () => {
    if (!hasScore) return;
    const safeScore = Math.max(0, Math.floor(score));
    const result = await shareUrl({
      title: `Beat ${safeScore.toLocaleString()} on ${tableName}`,
      text: `I scored ${safeScore.toLocaleString()} on ${tableName}. Can you beat it?`,
      url: buildScoreChallengeUrl(tableId, safeScore, challenger),
    });
    setStatus(feedback(result, 'challenge'));
  };

  return (
    <div className={`${styles.wrap} ${compact ? styles.compact : ''}`}>
      <div className={styles.buttons}>
        <button className="secondary" type="button" onClick={() => void shareTable()}>Share table</button>
        {hasScore && <button type="button" onClick={() => void shareChallenge()}>Challenge a friend</button>}
      </div>
      {status && <span className={styles.status} role="status">{status}</span>}
    </div>
  );
}
